var map = {
	"./Bidi_Class/Arabic_Letter": 65,
	"./Bidi_Class/Arabic_Letter.json": 65,
	"./Bidi_Class/Arabic_Number": 66,
	"./Bidi_Class/Arabic_Number.json": 66,
	"./Bidi_Class/Boundary_Neutral": 67,
	"./Bidi_Class/Boundary_Neutral.json": 67,
	"./Bidi_Class/Common_Separator": 68,
	"./Bidi_Class/Common_Separator.json": 68,
	"./Bidi_Class/European_Number": 69,
	"./Bidi_Class/European_Number.json": 69,
	"./Bidi_Class/European_Separator": 70,
	"./Bidi_Class/European_Separator.json": 70,
	"./Bidi_Class/European_Terminator": 71,
	"./Bidi_Class/European_Terminator.json": 71,
	"./Bidi_Class/First_Strong_Isolate": 72,
	"./Bidi_Class/First_Strong_Isolate.json": 72,
	"./Bidi_Class/Left_To_Right": 73,
	"./Bidi_Class/Left_To_Right.json": 73,
	"./Bidi_Class/Left_To_Right_Embedding": 74,
	"./Bidi_Class/Left_To_Right_Embedding.json": 74,
	"./Bidi_Class/Left_To_Right_Isolate": 75,
	"./Bidi_Class/Left_To_Right_Isolate.json": 75,
	"./Bidi_Class/Left_To_Right_Override": 76,
	"./Bidi_Class/Left_To_Right_Override.json": 76,
	"./Bidi_Class/Nonspacing_Mark": 77,
	"./Bidi_Class/Nonspacing_Mark.json": 77,
	"./Bidi_Class/Other_Neutral": 78,
	"./Bidi_Class/Other_Neutral.json": 78,
	"./Bidi_Class/Paragraph_Separator": 79,
	"./Bidi_Class/Paragraph_Separator.json": 79,
	"./Bidi_Class/Pop_Directional_Format": 80,
	"./Bidi_Class/Pop_Directional_Format.json": 80,
	"./Bidi_Class/Pop_Directional_Isolate": 81,
	"./Bidi_Class/Pop_Directional_Isolate.json": 81,
	"./Bidi_Class/Right_To_Left": 82,
	"./Bidi_Class/Right_To_Left.json": 82,
	"./Bidi_Class/Right_To_Left_Embedding": 83,
	"./Bidi_Class/Right_To_Left_Embedding.json": 83,
	"./Bidi_Class/Right_To_Left_Isolate": 84,
	"./Bidi_Class/Right_To_Left_Isolate.json": 84,
	"./Bidi_Class/Right_To_Left_Override": 85,
	"./Bidi_Class/Right_To_Left_Override.json": 85,
	"./Bidi_Class/Segment_Separator": 86,
	"./Bidi_Class/Segment_Separator.json": 86,
	"./Bidi_Class/White_Space": 87,
	"./Bidi_Class/White_Space.json": 87,
	"./Bidi_Paired_Bracket_Type/Close": 88,
	"./Bidi_Paired_Bracket_Type/Close.json": 88,
	"./Bidi_Paired_Bracket_Type/None": 89,
	"./Bidi_Paired_Bracket_Type/None.json": 89,
	"./Bidi_Paired_Bracket_Type/Open": 90,
	"./Bidi_Paired_Bracket_Type/Open.json": 90,
	"./Binary_Property/ASCII": 91,
	"./Binary_Property/ASCII.json": 91,
	"./Binary_Property/ASCII_Hex_Digit": 92,
	"./Binary_Property/ASCII_Hex_Digit.json": 92,
	"./Binary_Property/Alphabetic": 93,
	"./Binary_Property/Alphabetic.json": 93,
	"./Binary_Property/Any": 94,
	"./Binary_Property/Any.json": 94,
	"./Binary_Property/Assigned": 95,
	"./Binary_Property/Assigned.json": 95,
	"./Binary_Property/Bidi_Control": 96,
	"./Binary_Property/Bidi_Control.json": 96,
	"./Binary_Property/Bidi_Mirrored": 97,
	"./Binary_Property/Bidi_Mirrored.json": 97,
	"./Binary_Property/Case_Ignorable": 98,
	"./Binary_Property/Case_Ignorable.json": 98,
	"./Binary_Property/Cased": 99,
	"./Binary_Property/Cased.json": 99,
	"./Binary_Property/Changes_When_Casefolded": 100,
	"./Binary_Property/Changes_When_Casefolded.json": 100,
	"./Binary_Property/Changes_When_Casemapped": 101,
	"./Binary_Property/Changes_When_Casemapped.json": 101,
	"./Binary_Property/Changes_When_Lowercased": 102,
	"./Binary_Property/Changes_When_Lowercased.json": 102,
	"./Binary_Property/Changes_When_NFKC_Casefolded": 103,
	"./Binary_Property/Changes_When_NFKC_Casefolded.json": 103,
	"./Binary_Property/Changes_When_Titlecased": 104,
	"./Binary_Property/Changes_When_Titlecased.json": 104,
	"./Binary_Property/Changes_When_Uppercased": 105,
	"./Binary_Property/Changes_When_Uppercased.json": 105,
	"./Binary_Property/Composition_Exclusion": 106,
	"./Binary_Property/Composition_Exclusion.json": 106,
	"./Binary_Property/Dash": 107,
	"./Binary_Property/Dash.json": 107,
	"./Binary_Property/Default_Ignorable_Code_Point": 108,
	"./Binary_Property/Default_Ignorable_Code_Point.json": 108,
	"./Binary_Property/Deprecated": 109,
	"./Binary_Property/Deprecated.json": 109,
	"./Binary_Property/Diacritic": 110,
	"./Binary_Property/Diacritic.json": 110,
	"./Binary_Property/Expands_On_NFC": 111,
	"./Binary_Property/Expands_On_NFC.json": 111,
	"./Binary_Property/Expands_On_NFD": 112,
	"./Binary_Property/Expands_On_NFD.json": 112,
	"./Binary_Property/Expands_On_NFKC": 113,
	"./Binary_Property/Expands_On_NFKC.json": 113,
	"./Binary_Property/Expands_On_NFKD": 114,
	"./Binary_Property/Expands_On_NFKD.json": 114,
	"./Binary_Property/Extender": 115,
	"./Binary_Property/Extender.json": 115,
	"./Binary_Property/Full_Composition_Exclusion": 116,
	"./Binary_Property/Full_Composition_Exclusion.json": 116,
	"./Binary_Property/Grapheme_Base": 117,
	"./Binary_Property/Grapheme_Base.json": 117,
	"./Binary_Property/Grapheme_Extend": 118,
	"./Binary_Property/Grapheme_Extend.json": 118,
	"./Binary_Property/Grapheme_Link": 119,
	"./Binary_Property/Grapheme_Link.json": 119,
	"./Binary_Property/Hex_Digit": 120,
	"./Binary_Property/Hex_Digit.json": 120,
	"./Binary_Property/Hyphen": 121,
	"./Binary_Property/Hyphen.json": 121,
	"./Binary_Property/IDS_Binary_Operator": 122,
	"./Binary_Property/IDS_Binary_Operator.json": 122,
	"./Binary_Property/IDS_Trinary_Operator": 123,
	"./Binary_Property/IDS_Trinary_Operator.json": 123,
	"./Binary_Property/ID_Continue": 124,
	"./Binary_Property/ID_Continue.json": 124,
	"./Binary_Property/ID_Start": 125,
	"./Binary_Property/ID_Start.json": 125,
	"./Binary_Property/Ideographic": 126,
	"./Binary_Property/Ideographic.json": 126,
	"./Binary_Property/Join_Control": 127,
	"./Binary_Property/Join_Control.json": 127,
	"./Binary_Property/Logical_Order_Exception": 128,
	"./Binary_Property/Logical_Order_Exception.json": 128,
	"./Binary_Property/Lowercase": 129,
	"./Binary_Property/Lowercase.json": 129,
	"./Binary_Property/Math": 130,
	"./Binary_Property/Math.json": 130,
	"./Binary_Property/Noncharacter_Code_Point": 131,
	"./Binary_Property/Noncharacter_Code_Point.json": 131,
	"./Binary_Property/Other_Alphabetic": 132,
	"./Binary_Property/Other_Alphabetic.json": 132,
	"./Binary_Property/Other_Default_Ignorable_Code_Point": 133,
	"./Binary_Property/Other_Default_Ignorable_Code_Point.json": 133,
	"./Binary_Property/Other_Grapheme_Extend": 134,
	"./Binary_Property/Other_Grapheme_Extend.json": 134,
	"./Binary_Property/Other_ID_Continue": 135,
	"./Binary_Property/Other_ID_Continue.json": 135,
	"./Binary_Property/Other_ID_Start": 136,
	"./Binary_Property/Other_ID_Start.json": 136,
	"./Binary_Property/Other_Lowercase": 137,
	"./Binary_Property/Other_Lowercase.json": 137,
	"./Binary_Property/Other_Math": 138,
	"./Binary_Property/Other_Math.json": 138,
	"./Binary_Property/Other_Uppercase": 139,
	"./Binary_Property/Other_Uppercase.json": 139,
	"./Binary_Property/Pattern_Syntax": 140,
	"./Binary_Property/Pattern_Syntax.json": 140,
	"./Binary_Property/Pattern_White_Space": 141,
	"./Binary_Property/Pattern_White_Space.json": 141,
	"./Binary_Property/Prepended_Concatenation_Mark": 142,
	"./Binary_Property/Prepended_Concatenation_Mark.json": 142,
	"./Binary_Property/Quotation_Mark": 143,
	"./Binary_Property/Quotation_Mark.json": 143,
	"./Binary_Property/Radical": 144,
	"./Binary_Property/Radical.json": 144,
	"./Binary_Property/Regional_Indicator": 145,
	"./Binary_Property/Regional_Indicator.json": 145,
	"./Binary_Property/Sentence_Terminal": 146,
	"./Binary_Property/Sentence_Terminal.json": 146,
	"./Binary_Property/Soft_Dotted": 147,
	"./Binary_Property/Soft_Dotted.json": 147,
	"./Binary_Property/Terminal_Punctuation": 148,
	"./Binary_Property/Terminal_Punctuation.json": 148,
	"./Binary_Property/Unified_Ideograph": 149,
	"./Binary_Property/Unified_Ideograph.json": 149,
	"./Binary_Property/Uppercase": 150,
	"./Binary_Property/Uppercase.json": 150,
	"./Binary_Property/Variation_Selector": 151,
	"./Binary_Property/Variation_Selector.json": 151,
	"./Binary_Property/White_Space": 152,
	"./Binary_Property/White_Space.json": 152,
	"./Binary_Property/XID_Continue": 153,
	"./Binary_Property/XID_Continue.json": 153,
	"./Binary_Property/XID_Start": 154,
	"./Binary_Property/XID_Start.json": 154,
	"./Block/Adlam": 155,
	"./Block/Adlam.json": 155,
	"./Block/Aegean_Numbers": 156,
	"./Block/Aegean_Numbers.json": 156,
	"./Block/Ahom": 157,
	"./Block/Ahom.json": 157,
	"./Block/Alchemical_Symbols": 158,
	"./Block/Alchemical_Symbols.json": 158,
	"./Block/Alphabetic_Presentation_Forms": 159,
	"./Block/Alphabetic_Presentation_Forms.json": 159,
	"./Block/Anatolian_Hieroglyphs": 160,
	"./Block/Anatolian_Hieroglyphs.json": 160,
	"./Block/Ancient_Greek_Musical_Notation": 161,
	"./Block/Ancient_Greek_Musical_Notation.json": 161,
	"./Block/Ancient_Greek_Numbers": 162,
	"./Block/Ancient_Greek_Numbers.json": 162,
	"./Block/Ancient_Symbols": 163,
	"./Block/Ancient_Symbols.json": 163,
	"./Block/Arabic": 164,
	"./Block/Arabic.json": 164,
	"./Block/Arabic_Extended_A": 165,
	"./Block/Arabic_Extended_A.json": 165,
	"./Block/Arabic_Mathematical_Alphabetic_Symbols": 166,
	"./Block/Arabic_Mathematical_Alphabetic_Symbols.json": 166,
	"./Block/Arabic_Presentation_Forms_A": 167,
	"./Block/Arabic_Presentation_Forms_A.json": 167,
	"./Block/Arabic_Presentation_Forms_B": 168,
	"./Block/Arabic_Presentation_Forms_B.json": 168,
	"./Block/Arabic_Supplement": 169,
	"./Block/Arabic_Supplement.json": 169,
	"./Block/Armenian": 170,
	"./Block/Armenian.json": 170,
	"./Block/Arrows": 171,
	"./Block/Arrows.json": 171,
	"./Block/Avestan": 172,
	"./Block/Avestan.json": 172,
	"./Block/Balinese": 173,
	"./Block/Balinese.json": 173,
	"./Block/Bamum": 174,
	"./Block/Bamum.json": 174,
	"./Block/Bamum_Supplement": 175,
	"./Block/Bamum_Supplement.json": 175,
	"./Block/Basic_Latin": 176,
	"./Block/Basic_Latin.json": 176,
	"./Block/Bassa_Vah": 177,
	"./Block/Bassa_Vah.json": 177,
	"./Block/Batak": 178,
	"./Block/Batak.json": 178,
	"./Block/Bengali": 179,
	"./Block/Bengali.json": 179,
	"./Block/Bhaiksuki": 180,
	"./Block/Bhaiksuki.json": 180,
	"./Block/Block_Elements": 181,
	"./Block/Block_Elements.json": 181,
	"./Block/Bopomofo": 182,
	"./Block/Bopomofo.json": 182,
	"./Block/Bopomofo_Extended": 183,
	"./Block/Bopomofo_Extended.json": 183,
	"./Block/Box_Drawing": 184,
	"./Block/Box_Drawing.json": 184,
	"./Block/Brahmi": 185,
	"./Block/Brahmi.json": 185,
	"./Block/Braille_Patterns": 186,
	"./Block/Braille_Patterns.json": 186,
	"./Block/Buginese": 187,
	"./Block/Buginese.json": 187,
	"./Block/Buhid": 188,
	"./Block/Buhid.json": 188,
	"./Block/Byzantine_Musical_Symbols": 189,
	"./Block/Byzantine_Musical_Symbols.json": 189,
	"./Block/CJK_Compatibility": 190,
	"./Block/CJK_Compatibility.json": 190,
	"./Block/CJK_Compatibility_Forms": 191,
	"./Block/CJK_Compatibility_Forms.json": 191,
	"./Block/CJK_Compatibility_Ideographs": 192,
	"./Block/CJK_Compatibility_Ideographs.json": 192,
	"./Block/CJK_Compatibility_Ideographs_Supplement": 193,
	"./Block/CJK_Compatibility_Ideographs_Supplement.json": 193,
	"./Block/CJK_Radicals_Supplement": 194,
	"./Block/CJK_Radicals_Supplement.json": 194,
	"./Block/CJK_Strokes": 195,
	"./Block/CJK_Strokes.json": 195,
	"./Block/CJK_Symbols_And_Punctuation": 196,
	"./Block/CJK_Symbols_And_Punctuation.json": 196,
	"./Block/CJK_Unified_Ideographs": 197,
	"./Block/CJK_Unified_Ideographs.json": 197,
	"./Block/CJK_Unified_Ideographs_Extension_A": 198,
	"./Block/CJK_Unified_Ideographs_Extension_A.json": 198,
	"./Block/CJK_Unified_Ideographs_Extension_B": 199,
	"./Block/CJK_Unified_Ideographs_Extension_B.json": 199,
	"./Block/CJK_Unified_Ideographs_Extension_C": 200,
	"./Block/CJK_Unified_Ideographs_Extension_C.json": 200,
	"./Block/CJK_Unified_Ideographs_Extension_D": 201,
	"./Block/CJK_Unified_Ideographs_Extension_D.json": 201,
	"./Block/CJK_Unified_Ideographs_Extension_E": 202,
	"./Block/CJK_Unified_Ideographs_Extension_E.json": 202,
	"./Block/Carian": 203,
	"./Block/Carian.json": 203,
	"./Block/Caucasian_Albanian": 204,
	"./Block/Caucasian_Albanian.json": 204,
	"./Block/Chakma": 205,
	"./Block/Chakma.json": 205,
	"./Block/Cham": 206,
	"./Block/Cham.json": 206,
	"./Block/Cherokee": 207,
	"./Block/Cherokee.json": 207,
	"./Block/Cherokee_Supplement": 208,
	"./Block/Cherokee_Supplement.json": 208,
	"./Block/Combining_Diacritical_Marks": 209,
	"./Block/Combining_Diacritical_Marks.json": 209,
	"./Block/Combining_Diacritical_Marks_Extended": 210,
	"./Block/Combining_Diacritical_Marks_Extended.json": 210,
	"./Block/Combining_Diacritical_Marks_For_Symbols": 211,
	"./Block/Combining_Diacritical_Marks_For_Symbols.json": 211,
	"./Block/Combining_Diacritical_Marks_Supplement": 212,
	"./Block/Combining_Diacritical_Marks_Supplement.json": 212,
	"./Block/Combining_Half_Marks": 213,
	"./Block/Combining_Half_Marks.json": 213,
	"./Block/Common_Indic_Number_Forms": 214,
	"./Block/Common_Indic_Number_Forms.json": 214,
	"./Block/Control_Pictures": 215,
	"./Block/Control_Pictures.json": 215,
	"./Block/Coptic": 216,
	"./Block/Coptic.json": 216,
	"./Block/Coptic_Epact_Numbers": 217,
	"./Block/Coptic_Epact_Numbers.json": 217,
	"./Block/Counting_Rod_Numerals": 218,
	"./Block/Counting_Rod_Numerals.json": 218,
	"./Block/Cuneiform": 219,
	"./Block/Cuneiform.json": 219,
	"./Block/Cuneiform_Numbers_And_Punctuation": 220,
	"./Block/Cuneiform_Numbers_And_Punctuation.json": 220,
	"./Block/Currency_Symbols": 221,
	"./Block/Currency_Symbols.json": 221,
	"./Block/Cypriot_Syllabary": 222,
	"./Block/Cypriot_Syllabary.json": 222,
	"./Block/Cyrillic": 223,
	"./Block/Cyrillic.json": 223,
	"./Block/Cyrillic_Extended_A": 224,
	"./Block/Cyrillic_Extended_A.json": 224,
	"./Block/Cyrillic_Extended_B": 225,
	"./Block/Cyrillic_Extended_B.json": 225,
	"./Block/Cyrillic_Extended_C": 226,
	"./Block/Cyrillic_Extended_C.json": 226,
	"./Block/Cyrillic_Supplement": 227,
	"./Block/Cyrillic_Supplement.json": 227,
	"./Block/Deseret": 228,
	"./Block/Deseret.json": 228,
	"./Block/Devanagari": 229,
	"./Block/Devanagari.json": 229,
	"./Block/Devanagari_Extended": 230,
	"./Block/Devanagari_Extended.json": 230,
	"./Block/Dingbats": 231,
	"./Block/Dingbats.json": 231,
	"./Block/Domino_Tiles": 232,
	"./Block/Domino_Tiles.json": 232,
	"./Block/Duployan": 233,
	"./Block/Duployan.json": 233,
	"./Block/Early_Dynastic_Cuneiform": 234,
	"./Block/Early_Dynastic_Cuneiform.json": 234,
	"./Block/Egyptian_Hieroglyphs": 235,
	"./Block/Egyptian_Hieroglyphs.json": 235,
	"./Block/Elbasan": 236,
	"./Block/Elbasan.json": 236,
	"./Block/Emoticons": 237,
	"./Block/Emoticons.json": 237,
	"./Block/Enclosed_Alphanumeric_Supplement": 238,
	"./Block/Enclosed_Alphanumeric_Supplement.json": 238,
	"./Block/Enclosed_Alphanumerics": 239,
	"./Block/Enclosed_Alphanumerics.json": 239,
	"./Block/Enclosed_CJK_Letters_And_Months": 240,
	"./Block/Enclosed_CJK_Letters_And_Months.json": 240,
	"./Block/Enclosed_Ideographic_Supplement": 241,
	"./Block/Enclosed_Ideographic_Supplement.json": 241,
	"./Block/Ethiopic": 242,
	"./Block/Ethiopic.json": 242,
	"./Block/Ethiopic_Extended": 243,
	"./Block/Ethiopic_Extended.json": 243,
	"./Block/Ethiopic_Extended_A": 244,
	"./Block/Ethiopic_Extended_A.json": 244,
	"./Block/Ethiopic_Supplement": 245,
	"./Block/Ethiopic_Supplement.json": 245,
	"./Block/General_Punctuation": 246,
	"./Block/General_Punctuation.json": 246,
	"./Block/Geometric_Shapes": 247,
	"./Block/Geometric_Shapes.json": 247,
	"./Block/Geometric_Shapes_Extended": 248,
	"./Block/Geometric_Shapes_Extended.json": 248,
	"./Block/Georgian": 249,
	"./Block/Georgian.json": 249,
	"./Block/Georgian_Supplement": 250,
	"./Block/Georgian_Supplement.json": 250,
	"./Block/Glagolitic": 251,
	"./Block/Glagolitic.json": 251,
	"./Block/Glagolitic_Supplement": 252,
	"./Block/Glagolitic_Supplement.json": 252,
	"./Block/Gothic": 253,
	"./Block/Gothic.json": 253,
	"./Block/Grantha": 254,
	"./Block/Grantha.json": 254,
	"./Block/Greek_And_Coptic": 255,
	"./Block/Greek_And_Coptic.json": 255,
	"./Block/Greek_Extended": 256,
	"./Block/Greek_Extended.json": 256,
	"./Block/Gujarati": 257,
	"./Block/Gujarati.json": 257,
	"./Block/Gurmukhi": 258,
	"./Block/Gurmukhi.json": 258,
	"./Block/Halfwidth_And_Fullwidth_Forms": 259,
	"./Block/Halfwidth_And_Fullwidth_Forms.json": 259,
	"./Block/Hangul_Compatibility_Jamo": 260,
	"./Block/Hangul_Compatibility_Jamo.json": 260,
	"./Block/Hangul_Jamo": 261,
	"./Block/Hangul_Jamo.json": 261,
	"./Block/Hangul_Jamo_Extended_A": 262,
	"./Block/Hangul_Jamo_Extended_A.json": 262,
	"./Block/Hangul_Jamo_Extended_B": 263,
	"./Block/Hangul_Jamo_Extended_B.json": 263,
	"./Block/Hangul_Syllables": 264,
	"./Block/Hangul_Syllables.json": 264,
	"./Block/Hanunoo": 265,
	"./Block/Hanunoo.json": 265,
	"./Block/Hatran": 266,
	"./Block/Hatran.json": 266,
	"./Block/Hebrew": 267,
	"./Block/Hebrew.json": 267,
	"./Block/High_Private_Use_Surrogates": 268,
	"./Block/High_Private_Use_Surrogates.json": 268,
	"./Block/High_Surrogates": 269,
	"./Block/High_Surrogates.json": 269,
	"./Block/Hiragana": 270,
	"./Block/Hiragana.json": 270,
	"./Block/IPA_Extensions": 271,
	"./Block/IPA_Extensions.json": 271,
	"./Block/Ideographic_Description_Characters": 272,
	"./Block/Ideographic_Description_Characters.json": 272,
	"./Block/Ideographic_Symbols_And_Punctuation": 273,
	"./Block/Ideographic_Symbols_And_Punctuation.json": 273,
	"./Block/Imperial_Aramaic": 274,
	"./Block/Imperial_Aramaic.json": 274,
	"./Block/Inscriptional_Pahlavi": 275,
	"./Block/Inscriptional_Pahlavi.json": 275,
	"./Block/Inscriptional_Parthian": 276,
	"./Block/Inscriptional_Parthian.json": 276,
	"./Block/Javanese": 277,
	"./Block/Javanese.json": 277,
	"./Block/Kaithi": 278,
	"./Block/Kaithi.json": 278,
	"./Block/Kana_Supplement": 279,
	"./Block/Kana_Supplement.json": 279,
	"./Block/Kanbun": 280,
	"./Block/Kanbun.json": 280,
	"./Block/Kangxi_Radicals": 281,
	"./Block/Kangxi_Radicals.json": 281,
	"./Block/Kannada": 282,
	"./Block/Kannada.json": 282,
	"./Block/Katakana": 283,
	"./Block/Katakana.json": 283,
	"./Block/Katakana_Phonetic_Extensions": 284,
	"./Block/Katakana_Phonetic_Extensions.json": 284,
	"./Block/Kayah_Li": 285,
	"./Block/Kayah_Li.json": 285,
	"./Block/Kharoshthi": 286,
	"./Block/Kharoshthi.json": 286,
	"./Block/Khmer": 287,
	"./Block/Khmer.json": 287,
	"./Block/Khmer_Symbols": 288,
	"./Block/Khmer_Symbols.json": 288,
	"./Block/Khojki": 289,
	"./Block/Khojki.json": 289,
	"./Block/Khudawadi": 290,
	"./Block/Khudawadi.json": 290,
	"./Block/Lao": 291,
	"./Block/Lao.json": 291,
	"./Block/Latin_1_Supplement": 292,
	"./Block/Latin_1_Supplement.json": 292,
	"./Block/Latin_Extended_A": 293,
	"./Block/Latin_Extended_A.json": 293,
	"./Block/Latin_Extended_Additional": 294,
	"./Block/Latin_Extended_Additional.json": 294,
	"./Block/Latin_Extended_B": 295,
	"./Block/Latin_Extended_B.json": 295,
	"./Block/Latin_Extended_C": 296,
	"./Block/Latin_Extended_C.json": 296,
	"./Block/Latin_Extended_D": 297,
	"./Block/Latin_Extended_D.json": 297,
	"./Block/Latin_Extended_E": 298,
	"./Block/Latin_Extended_E.json": 298,
	"./Block/Lepcha": 299,
	"./Block/Lepcha.json": 299,
	"./Block/Letterlike_Symbols": 300,
	"./Block/Letterlike_Symbols.json": 300,
	"./Block/Limbu": 301,
	"./Block/Limbu.json": 301,
	"./Block/Linear_A": 302,
	"./Block/Linear_A.json": 302,
	"./Block/Linear_B_Ideograms": 303,
	"./Block/Linear_B_Ideograms.json": 303,
	"./Block/Linear_B_Syllabary": 304,
	"./Block/Linear_B_Syllabary.json": 304,
	"./Block/Lisu": 305,
	"./Block/Lisu.json": 305,
	"./Block/Low_Surrogates": 306,
	"./Block/Low_Surrogates.json": 306,
	"./Block/Lycian": 307,
	"./Block/Lycian.json": 307,
	"./Block/Lydian": 308,
	"./Block/Lydian.json": 308,
	"./Block/Mahajani": 309,
	"./Block/Mahajani.json": 309,
	"./Block/Mahjong_Tiles": 310,
	"./Block/Mahjong_Tiles.json": 310,
	"./Block/Malayalam": 311,
	"./Block/Malayalam.json": 311,
	"./Block/Mandaic": 312,
	"./Block/Mandaic.json": 312,
	"./Block/Manichaean": 313,
	"./Block/Manichaean.json": 313,
	"./Block/Marchen": 314,
	"./Block/Marchen.json": 314,
	"./Block/Mathematical_Alphanumeric_Symbols": 315,
	"./Block/Mathematical_Alphanumeric_Symbols.json": 315,
	"./Block/Mathematical_Operators": 316,
	"./Block/Mathematical_Operators.json": 316,
	"./Block/Meetei_Mayek": 317,
	"./Block/Meetei_Mayek.json": 317,
	"./Block/Meetei_Mayek_Extensions": 318,
	"./Block/Meetei_Mayek_Extensions.json": 318,
	"./Block/Mende_Kikakui": 319,
	"./Block/Mende_Kikakui.json": 319,
	"./Block/Meroitic_Cursive": 320,
	"./Block/Meroitic_Cursive.json": 320,
	"./Block/Meroitic_Hieroglyphs": 321,
	"./Block/Meroitic_Hieroglyphs.json": 321,
	"./Block/Miao": 322,
	"./Block/Miao.json": 322,
	"./Block/Miscellaneous_Mathematical_Symbols_A": 323,
	"./Block/Miscellaneous_Mathematical_Symbols_A.json": 323,
	"./Block/Miscellaneous_Mathematical_Symbols_B": 324,
	"./Block/Miscellaneous_Mathematical_Symbols_B.json": 324,
	"./Block/Miscellaneous_Symbols": 325,
	"./Block/Miscellaneous_Symbols.json": 325,
	"./Block/Miscellaneous_Symbols_And_Arrows": 326,
	"./Block/Miscellaneous_Symbols_And_Arrows.json": 326,
	"./Block/Miscellaneous_Symbols_And_Pictographs": 327,
	"./Block/Miscellaneous_Symbols_And_Pictographs.json": 327,
	"./Block/Miscellaneous_Technical": 328,
	"./Block/Miscellaneous_Technical.json": 328,
	"./Block/Modi": 329,
	"./Block/Modi.json": 329,
	"./Block/Modifier_Tone_Letters": 330,
	"./Block/Modifier_Tone_Letters.json": 330,
	"./Block/Mongolian": 331,
	"./Block/Mongolian.json": 331,
	"./Block/Mongolian_Supplement": 332,
	"./Block/Mongolian_Supplement.json": 332,
	"./Block/Mro": 333,
	"./Block/Mro.json": 333,
	"./Block/Multani": 334,
	"./Block/Multani.json": 334,
	"./Block/Musical_Symbols": 335,
	"./Block/Musical_Symbols.json": 335,
	"./Block/Myanmar": 336,
	"./Block/Myanmar.json": 336,
	"./Block/Myanmar_Extended_A": 337,
	"./Block/Myanmar_Extended_A.json": 337,
	"./Block/Myanmar_Extended_B": 338,
	"./Block/Myanmar_Extended_B.json": 338,
	"./Block/NKo": 339,
	"./Block/NKo.json": 339,
	"./Block/Nabataean": 340,
	"./Block/Nabataean.json": 340,
	"./Block/New_Tai_Lue": 341,
	"./Block/New_Tai_Lue.json": 341,
	"./Block/Newa": 342,
	"./Block/Newa.json": 342,
	"./Block/Number_Forms": 343,
	"./Block/Number_Forms.json": 343,
	"./Block/Ogham": 344,
	"./Block/Ogham.json": 344,
	"./Block/Ol_Chiki": 345,
	"./Block/Ol_Chiki.json": 345,
	"./Block/Old_Hungarian": 346,
	"./Block/Old_Hungarian.json": 346,
	"./Block/Old_Italic": 347,
	"./Block/Old_Italic.json": 347,
	"./Block/Old_North_Arabian": 348,
	"./Block/Old_North_Arabian.json": 348,
	"./Block/Old_Permic": 349,
	"./Block/Old_Permic.json": 349,
	"./Block/Old_Persian": 350,
	"./Block/Old_Persian.json": 350,
	"./Block/Old_South_Arabian": 351,
	"./Block/Old_South_Arabian.json": 351,
	"./Block/Old_Turkic": 352,
	"./Block/Old_Turkic.json": 352,
	"./Block/Optical_Character_Recognition": 353,
	"./Block/Optical_Character_Recognition.json": 353,
	"./Block/Oriya": 354,
	"./Block/Oriya.json": 354,
	"./Block/Ornamental_Dingbats": 355,
	"./Block/Ornamental_Dingbats.json": 355,
	"./Block/Osage": 356,
	"./Block/Osage.json": 356,
	"./Block/Osmanya": 357,
	"./Block/Osmanya.json": 357,
	"./Block/Pahawh_Hmong": 358,
	"./Block/Pahawh_Hmong.json": 358,
	"./Block/Palmyrene": 359,
	"./Block/Palmyrene.json": 359,
	"./Block/Pau_Cin_Hau": 360,
	"./Block/Pau_Cin_Hau.json": 360,
	"./Block/Phags_Pa": 361,
	"./Block/Phags_Pa.json": 361,
	"./Block/Phaistos_Disc": 362,
	"./Block/Phaistos_Disc.json": 362,
	"./Block/Phoenician": 363,
	"./Block/Phoenician.json": 363,
	"./Block/Phonetic_Extensions": 364,
	"./Block/Phonetic_Extensions.json": 364,
	"./Block/Phonetic_Extensions_Supplement": 365,
	"./Block/Phonetic_Extensions_Supplement.json": 365,
	"./Block/Playing_Cards": 366,
	"./Block/Playing_Cards.json": 366,
	"./Block/Private_Use_Area": 367,
	"./Block/Private_Use_Area.json": 367,
	"./Block/Psalter_Pahlavi": 368,
	"./Block/Psalter_Pahlavi.json": 368,
	"./Block/Rejang": 369,
	"./Block/Rejang.json": 369,
	"./Block/Rumi_Numeral_Symbols": 370,
	"./Block/Rumi_Numeral_Symbols.json": 370,
	"./Block/Runic": 371,
	"./Block/Runic.json": 371,
	"./Block/Samaritan": 372,
	"./Block/Samaritan.json": 372,
	"./Block/Saurashtra": 373,
	"./Block/Saurashtra.json": 373,
	"./Block/Sharada": 374,
	"./Block/Sharada.json": 374,
	"./Block/Shavian": 375,
	"./Block/Shavian.json": 375,
	"./Block/Shorthand_Format_Controls": 376,
	"./Block/Shorthand_Format_Controls.json": 376,
	"./Block/Siddham": 377,
	"./Block/Siddham.json": 377,
	"./Block/Sinhala": 378,
	"./Block/Sinhala.json": 378,
	"./Block/Sinhala_Archaic_Numbers": 379,
	"./Block/Sinhala_Archaic_Numbers.json": 379,
	"./Block/Small_Form_Variants": 380,
	"./Block/Small_Form_Variants.json": 380,
	"./Block/Sora_Sompeng": 381,
	"./Block/Sora_Sompeng.json": 381,
	"./Block/Spacing_Modifier_Letters": 382,
	"./Block/Spacing_Modifier_Letters.json": 382,
	"./Block/Specials": 383,
	"./Block/Specials.json": 383,
	"./Block/Sundanese": 384,
	"./Block/Sundanese.json": 384,
	"./Block/Sundanese_Supplement": 385,
	"./Block/Sundanese_Supplement.json": 385,
	"./Block/Superscripts_And_Subscripts": 386,
	"./Block/Superscripts_And_Subscripts.json": 386,
	"./Block/Supplemental_Arrows_A": 387,
	"./Block/Supplemental_Arrows_A.json": 387,
	"./Block/Supplemental_Arrows_B": 388,
	"./Block/Supplemental_Arrows_B.json": 388,
	"./Block/Supplemental_Arrows_C": 389,
	"./Block/Supplemental_Arrows_C.json": 389,
	"./Block/Supplemental_Mathematical_Operators": 390,
	"./Block/Supplemental_Mathematical_Operators.json": 390,
	"./Block/Supplemental_Punctuation": 391,
	"./Block/Supplemental_Punctuation.json": 391,
	"./Block/Supplemental_Symbols_And_Pictographs": 392,
	"./Block/Supplemental_Symbols_And_Pictographs.json": 392,
	"./Block/Supplementary_Private_Use_Area_A": 393,
	"./Block/Supplementary_Private_Use_Area_A.json": 393,
	"./Block/Supplementary_Private_Use_Area_B": 394,
	"./Block/Supplementary_Private_Use_Area_B.json": 394,
	"./Block/Sutton_SignWriting": 395,
	"./Block/Sutton_SignWriting.json": 395,
	"./Block/Syloti_Nagri": 396,
	"./Block/Syloti_Nagri.json": 396,
	"./Block/Syriac": 397,
	"./Block/Syriac.json": 397,
	"./Block/Tagalog": 398,
	"./Block/Tagalog.json": 398,
	"./Block/Tagbanwa": 399,
	"./Block/Tagbanwa.json": 399,
	"./Block/Tags": 400,
	"./Block/Tags.json": 400,
	"./Block/Tai_Le": 401,
	"./Block/Tai_Le.json": 401,
	"./Block/Tai_Tham": 402,
	"./Block/Tai_Tham.json": 402,
	"./Block/Tai_Viet": 403,
	"./Block/Tai_Viet.json": 403,
	"./Block/Tai_Xuan_Jing_Symbols": 404,
	"./Block/Tai_Xuan_Jing_Symbols.json": 404,
	"./Block/Takri": 405,
	"./Block/Takri.json": 405,
	"./Block/Tamil": 406,
	"./Block/Tamil.json": 406,
	"./Block/Tangut": 407,
	"./Block/Tangut.json": 407,
	"./Block/Tangut_Components": 408,
	"./Block/Tangut_Components.json": 408,
	"./Block/Telugu": 409,
	"./Block/Telugu.json": 409,
	"./Block/Thaana": 410,
	"./Block/Thaana.json": 410,
	"./Block/Thai": 411,
	"./Block/Thai.json": 411,
	"./Block/Tibetan": 412,
	"./Block/Tibetan.json": 412,
	"./Block/Tifinagh": 413,
	"./Block/Tifinagh.json": 413,
	"./Block/Tirhuta": 414,
	"./Block/Tirhuta.json": 414,
	"./Block/Transport_And_Map_Symbols": 415,
	"./Block/Transport_And_Map_Symbols.json": 415,
	"./Block/Ugaritic": 416,
	"./Block/Ugaritic.json": 416,
	"./Block/Unified_Canadian_Aboriginal_Syllabics": 417,
	"./Block/Unified_Canadian_Aboriginal_Syllabics.json": 417,
	"./Block/Unified_Canadian_Aboriginal_Syllabics_Extended": 418,
	"./Block/Unified_Canadian_Aboriginal_Syllabics_Extended.json": 418,
	"./Block/Vai": 419,
	"./Block/Vai.json": 419,
	"./Block/Variation_Selectors": 420,
	"./Block/Variation_Selectors.json": 420,
	"./Block/Variation_Selectors_Supplement": 421,
	"./Block/Variation_Selectors_Supplement.json": 421,
	"./Block/Vedic_Extensions": 422,
	"./Block/Vedic_Extensions.json": 422,
	"./Block/Vertical_Forms": 423,
	"./Block/Vertical_Forms.json": 423,
	"./Block/Warang_Citi": 424,
	"./Block/Warang_Citi.json": 424,
	"./Block/Yi_Radicals": 425,
	"./Block/Yi_Radicals.json": 425,
	"./Block/Yi_Syllables": 426,
	"./Block/Yi_Syllables.json": 426,
	"./Block/Yijing_Hexagram_Symbols": 427,
	"./Block/Yijing_Hexagram_Symbols.json": 427,
	"./Block/undefined": 428,
	"./Block/undefined.json": 428,
	"./Case_Folding/C": 429,
	"./Case_Folding/C.json": 429,
	"./Case_Folding/F": 430,
	"./Case_Folding/F.json": 430,
	"./Case_Folding/S": 431,
	"./Case_Folding/S.json": 431,
	"./Case_Folding/T": 432,
	"./Case_Folding/T.json": 432,
	"./General_Category/Cased_Letter": 433,
	"./General_Category/Cased_Letter.json": 433,
	"./General_Category/Close_Punctuation": 434,
	"./General_Category/Close_Punctuation.json": 434,
	"./General_Category/Connector_Punctuation": 435,
	"./General_Category/Connector_Punctuation.json": 435,
	"./General_Category/Control": 436,
	"./General_Category/Control.json": 436,
	"./General_Category/Currency_Symbol": 437,
	"./General_Category/Currency_Symbol.json": 437,
	"./General_Category/Dash_Punctuation": 438,
	"./General_Category/Dash_Punctuation.json": 438,
	"./General_Category/Decimal_Number": 439,
	"./General_Category/Decimal_Number.json": 439,
	"./General_Category/Enclosing_Mark": 440,
	"./General_Category/Enclosing_Mark.json": 440,
	"./General_Category/Final_Punctuation": 441,
	"./General_Category/Final_Punctuation.json": 441,
	"./General_Category/Format": 442,
	"./General_Category/Format.json": 442,
	"./General_Category/Initial_Punctuation": 443,
	"./General_Category/Initial_Punctuation.json": 443,
	"./General_Category/Letter": 444,
	"./General_Category/Letter.json": 444,
	"./General_Category/Letter_Number": 445,
	"./General_Category/Letter_Number.json": 445,
	"./General_Category/Line_Separator": 446,
	"./General_Category/Line_Separator.json": 446,
	"./General_Category/Lowercase_Letter": 447,
	"./General_Category/Lowercase_Letter.json": 447,
	"./General_Category/Mark": 448,
	"./General_Category/Mark.json": 448,
	"./General_Category/Math_Symbol": 449,
	"./General_Category/Math_Symbol.json": 449,
	"./General_Category/Modifier_Letter": 450,
	"./General_Category/Modifier_Letter.json": 450,
	"./General_Category/Modifier_Symbol": 451,
	"./General_Category/Modifier_Symbol.json": 451,
	"./General_Category/Nonspacing_Mark": 452,
	"./General_Category/Nonspacing_Mark.json": 452,
	"./General_Category/Number": 453,
	"./General_Category/Number.json": 453,
	"./General_Category/Open_Punctuation": 454,
	"./General_Category/Open_Punctuation.json": 454,
	"./General_Category/Other": 455,
	"./General_Category/Other.json": 455,
	"./General_Category/Other_Letter": 456,
	"./General_Category/Other_Letter.json": 456,
	"./General_Category/Other_Number": 457,
	"./General_Category/Other_Number.json": 457,
	"./General_Category/Other_Punctuation": 458,
	"./General_Category/Other_Punctuation.json": 458,
	"./General_Category/Other_Symbol": 459,
	"./General_Category/Other_Symbol.json": 459,
	"./General_Category/Paragraph_Separator": 460,
	"./General_Category/Paragraph_Separator.json": 460,
	"./General_Category/Private_Use": 461,
	"./General_Category/Private_Use.json": 461,
	"./General_Category/Punctuation": 462,
	"./General_Category/Punctuation.json": 462,
	"./General_Category/Separator": 463,
	"./General_Category/Separator.json": 463,
	"./General_Category/Space_Separator": 464,
	"./General_Category/Space_Separator.json": 464,
	"./General_Category/Spacing_Mark": 465,
	"./General_Category/Spacing_Mark.json": 465,
	"./General_Category/Surrogate": 466,
	"./General_Category/Surrogate.json": 466,
	"./General_Category/Symbol": 467,
	"./General_Category/Symbol.json": 467,
	"./General_Category/Titlecase_Letter": 468,
	"./General_Category/Titlecase_Letter.json": 468,
	"./General_Category/Unassigned": 469,
	"./General_Category/Unassigned.json": 469,
	"./General_Category/Uppercase_Letter": 470,
	"./General_Category/Uppercase_Letter.json": 470,
	"./Line_Break/Alphabetic": 471,
	"./Line_Break/Alphabetic.json": 471,
	"./Line_Break/Ambiguous": 472,
	"./Line_Break/Ambiguous.json": 472,
	"./Line_Break/Break_After": 473,
	"./Line_Break/Break_After.json": 473,
	"./Line_Break/Break_Before": 474,
	"./Line_Break/Break_Before.json": 474,
	"./Line_Break/Break_Both": 475,
	"./Line_Break/Break_Both.json": 475,
	"./Line_Break/Break_Symbols": 476,
	"./Line_Break/Break_Symbols.json": 476,
	"./Line_Break/Carriage_Return": 477,
	"./Line_Break/Carriage_Return.json": 477,
	"./Line_Break/Close_Parenthesis": 478,
	"./Line_Break/Close_Parenthesis.json": 478,
	"./Line_Break/Close_Punctuation": 479,
	"./Line_Break/Close_Punctuation.json": 479,
	"./Line_Break/Combining_Mark": 480,
	"./Line_Break/Combining_Mark.json": 480,
	"./Line_Break/Complex_Context": 481,
	"./Line_Break/Complex_Context.json": 481,
	"./Line_Break/Conditional_Japanese_Starter": 482,
	"./Line_Break/Conditional_Japanese_Starter.json": 482,
	"./Line_Break/Contingent_Break": 483,
	"./Line_Break/Contingent_Break.json": 483,
	"./Line_Break/E_Base": 484,
	"./Line_Break/E_Base.json": 484,
	"./Line_Break/E_Modifier": 485,
	"./Line_Break/E_Modifier.json": 485,
	"./Line_Break/Exclamation": 486,
	"./Line_Break/Exclamation.json": 486,
	"./Line_Break/Glue": 487,
	"./Line_Break/Glue.json": 487,
	"./Line_Break/H2": 488,
	"./Line_Break/H2.json": 488,
	"./Line_Break/H3": 489,
	"./Line_Break/H3.json": 489,
	"./Line_Break/Hebrew_Letter": 490,
	"./Line_Break/Hebrew_Letter.json": 490,
	"./Line_Break/Hyphen": 491,
	"./Line_Break/Hyphen.json": 491,
	"./Line_Break/Ideographic": 492,
	"./Line_Break/Ideographic.json": 492,
	"./Line_Break/Infix_Numeric": 493,
	"./Line_Break/Infix_Numeric.json": 493,
	"./Line_Break/Inseparable": 494,
	"./Line_Break/Inseparable.json": 494,
	"./Line_Break/JL": 495,
	"./Line_Break/JL.json": 495,
	"./Line_Break/JT": 496,
	"./Line_Break/JT.json": 496,
	"./Line_Break/JV": 497,
	"./Line_Break/JV.json": 497,
	"./Line_Break/Line_Feed": 498,
	"./Line_Break/Line_Feed.json": 498,
	"./Line_Break/Mandatory_Break": 499,
	"./Line_Break/Mandatory_Break.json": 499,
	"./Line_Break/Next_Line": 500,
	"./Line_Break/Next_Line.json": 500,
	"./Line_Break/Nonstarter": 501,
	"./Line_Break/Nonstarter.json": 501,
	"./Line_Break/Numeric": 502,
	"./Line_Break/Numeric.json": 502,
	"./Line_Break/Open_Punctuation": 503,
	"./Line_Break/Open_Punctuation.json": 503,
	"./Line_Break/Postfix_Numeric": 504,
	"./Line_Break/Postfix_Numeric.json": 504,
	"./Line_Break/Prefix_Numeric": 505,
	"./Line_Break/Prefix_Numeric.json": 505,
	"./Line_Break/Quotation": 506,
	"./Line_Break/Quotation.json": 506,
	"./Line_Break/Regional_Indicator": 507,
	"./Line_Break/Regional_Indicator.json": 507,
	"./Line_Break/Space": 508,
	"./Line_Break/Space.json": 508,
	"./Line_Break/Surrogate": 509,
	"./Line_Break/Surrogate.json": 509,
	"./Line_Break/Unknown": 510,
	"./Line_Break/Unknown.json": 510,
	"./Line_Break/Word_Joiner": 511,
	"./Line_Break/Word_Joiner.json": 511,
	"./Line_Break/ZWJ": 512,
	"./Line_Break/ZWJ.json": 512,
	"./Line_Break/ZWSpace": 513,
	"./Line_Break/ZWSpace.json": 513,
	"./Script/Adlam": 514,
	"./Script/Adlam.json": 514,
	"./Script/Ahom": 515,
	"./Script/Ahom.json": 515,
	"./Script/Anatolian_Hieroglyphs": 516,
	"./Script/Anatolian_Hieroglyphs.json": 516,
	"./Script/Arabic": 517,
	"./Script/Arabic.json": 517,
	"./Script/Armenian": 518,
	"./Script/Armenian.json": 518,
	"./Script/Avestan": 519,
	"./Script/Avestan.json": 519,
	"./Script/Balinese": 520,
	"./Script/Balinese.json": 520,
	"./Script/Bamum": 521,
	"./Script/Bamum.json": 521,
	"./Script/Bassa_Vah": 522,
	"./Script/Bassa_Vah.json": 522,
	"./Script/Batak": 523,
	"./Script/Batak.json": 523,
	"./Script/Bengali": 524,
	"./Script/Bengali.json": 524,
	"./Script/Bhaiksuki": 525,
	"./Script/Bhaiksuki.json": 525,
	"./Script/Bopomofo": 526,
	"./Script/Bopomofo.json": 526,
	"./Script/Brahmi": 527,
	"./Script/Brahmi.json": 527,
	"./Script/Braille": 528,
	"./Script/Braille.json": 528,
	"./Script/Buginese": 529,
	"./Script/Buginese.json": 529,
	"./Script/Buhid": 530,
	"./Script/Buhid.json": 530,
	"./Script/Canadian_Aboriginal": 531,
	"./Script/Canadian_Aboriginal.json": 531,
	"./Script/Carian": 532,
	"./Script/Carian.json": 532,
	"./Script/Caucasian_Albanian": 533,
	"./Script/Caucasian_Albanian.json": 533,
	"./Script/Chakma": 534,
	"./Script/Chakma.json": 534,
	"./Script/Cham": 535,
	"./Script/Cham.json": 535,
	"./Script/Cherokee": 536,
	"./Script/Cherokee.json": 536,
	"./Script/Common": 537,
	"./Script/Common.json": 537,
	"./Script/Coptic": 538,
	"./Script/Coptic.json": 538,
	"./Script/Cuneiform": 539,
	"./Script/Cuneiform.json": 539,
	"./Script/Cypriot": 540,
	"./Script/Cypriot.json": 540,
	"./Script/Cyrillic": 541,
	"./Script/Cyrillic.json": 541,
	"./Script/Deseret": 542,
	"./Script/Deseret.json": 542,
	"./Script/Devanagari": 543,
	"./Script/Devanagari.json": 543,
	"./Script/Duployan": 544,
	"./Script/Duployan.json": 544,
	"./Script/Egyptian_Hieroglyphs": 545,
	"./Script/Egyptian_Hieroglyphs.json": 545,
	"./Script/Elbasan": 546,
	"./Script/Elbasan.json": 546,
	"./Script/Ethiopic": 547,
	"./Script/Ethiopic.json": 547,
	"./Script/Georgian": 548,
	"./Script/Georgian.json": 548,
	"./Script/Glagolitic": 549,
	"./Script/Glagolitic.json": 549,
	"./Script/Gothic": 550,
	"./Script/Gothic.json": 550,
	"./Script/Grantha": 551,
	"./Script/Grantha.json": 551,
	"./Script/Greek": 552,
	"./Script/Greek.json": 552,
	"./Script/Gujarati": 553,
	"./Script/Gujarati.json": 553,
	"./Script/Gurmukhi": 554,
	"./Script/Gurmukhi.json": 554,
	"./Script/Han": 555,
	"./Script/Han.json": 555,
	"./Script/Hangul": 556,
	"./Script/Hangul.json": 556,
	"./Script/Hanunoo": 557,
	"./Script/Hanunoo.json": 557,
	"./Script/Hatran": 558,
	"./Script/Hatran.json": 558,
	"./Script/Hebrew": 559,
	"./Script/Hebrew.json": 559,
	"./Script/Hiragana": 560,
	"./Script/Hiragana.json": 560,
	"./Script/Imperial_Aramaic": 561,
	"./Script/Imperial_Aramaic.json": 561,
	"./Script/Inherited": 562,
	"./Script/Inherited.json": 562,
	"./Script/Inscriptional_Pahlavi": 563,
	"./Script/Inscriptional_Pahlavi.json": 563,
	"./Script/Inscriptional_Parthian": 564,
	"./Script/Inscriptional_Parthian.json": 564,
	"./Script/Javanese": 565,
	"./Script/Javanese.json": 565,
	"./Script/Kaithi": 566,
	"./Script/Kaithi.json": 566,
	"./Script/Kannada": 567,
	"./Script/Kannada.json": 567,
	"./Script/Katakana": 568,
	"./Script/Katakana.json": 568,
	"./Script/Kayah_Li": 569,
	"./Script/Kayah_Li.json": 569,
	"./Script/Kharoshthi": 570,
	"./Script/Kharoshthi.json": 570,
	"./Script/Khmer": 571,
	"./Script/Khmer.json": 571,
	"./Script/Khojki": 572,
	"./Script/Khojki.json": 572,
	"./Script/Khudawadi": 573,
	"./Script/Khudawadi.json": 573,
	"./Script/Lao": 574,
	"./Script/Lao.json": 574,
	"./Script/Latin": 575,
	"./Script/Latin.json": 575,
	"./Script/Lepcha": 576,
	"./Script/Lepcha.json": 576,
	"./Script/Limbu": 577,
	"./Script/Limbu.json": 577,
	"./Script/Linear_A": 578,
	"./Script/Linear_A.json": 578,
	"./Script/Linear_B": 579,
	"./Script/Linear_B.json": 579,
	"./Script/Lisu": 580,
	"./Script/Lisu.json": 580,
	"./Script/Lycian": 581,
	"./Script/Lycian.json": 581,
	"./Script/Lydian": 582,
	"./Script/Lydian.json": 582,
	"./Script/Mahajani": 583,
	"./Script/Mahajani.json": 583,
	"./Script/Malayalam": 584,
	"./Script/Malayalam.json": 584,
	"./Script/Mandaic": 585,
	"./Script/Mandaic.json": 585,
	"./Script/Manichaean": 586,
	"./Script/Manichaean.json": 586,
	"./Script/Marchen": 587,
	"./Script/Marchen.json": 587,
	"./Script/Masaram_Gondi": 588,
	"./Script/Masaram_Gondi.json": 588,
	"./Script/Meetei_Mayek": 589,
	"./Script/Meetei_Mayek.json": 589,
	"./Script/Mende_Kikakui": 590,
	"./Script/Mende_Kikakui.json": 590,
	"./Script/Meroitic_Cursive": 591,
	"./Script/Meroitic_Cursive.json": 591,
	"./Script/Meroitic_Hieroglyphs": 592,
	"./Script/Meroitic_Hieroglyphs.json": 592,
	"./Script/Miao": 593,
	"./Script/Miao.json": 593,
	"./Script/Modi": 594,
	"./Script/Modi.json": 594,
	"./Script/Mongolian": 595,
	"./Script/Mongolian.json": 595,
	"./Script/Mro": 596,
	"./Script/Mro.json": 596,
	"./Script/Multani": 597,
	"./Script/Multani.json": 597,
	"./Script/Myanmar": 598,
	"./Script/Myanmar.json": 598,
	"./Script/Nabataean": 599,
	"./Script/Nabataean.json": 599,
	"./Script/New_Tai_Lue": 600,
	"./Script/New_Tai_Lue.json": 600,
	"./Script/Newa": 601,
	"./Script/Newa.json": 601,
	"./Script/Nko": 602,
	"./Script/Nko.json": 602,
	"./Script/Nushu": 603,
	"./Script/Nushu.json": 603,
	"./Script/Ogham": 604,
	"./Script/Ogham.json": 604,
	"./Script/Ol_Chiki": 605,
	"./Script/Ol_Chiki.json": 605,
	"./Script/Old_Hungarian": 606,
	"./Script/Old_Hungarian.json": 606,
	"./Script/Old_Italic": 607,
	"./Script/Old_Italic.json": 607,
	"./Script/Old_North_Arabian": 608,
	"./Script/Old_North_Arabian.json": 608,
	"./Script/Old_Permic": 609,
	"./Script/Old_Permic.json": 609,
	"./Script/Old_Persian": 610,
	"./Script/Old_Persian.json": 610,
	"./Script/Old_South_Arabian": 611,
	"./Script/Old_South_Arabian.json": 611,
	"./Script/Old_Turkic": 612,
	"./Script/Old_Turkic.json": 612,
	"./Script/Oriya": 613,
	"./Script/Oriya.json": 613,
	"./Script/Osage": 614,
	"./Script/Osage.json": 614,
	"./Script/Osmanya": 615,
	"./Script/Osmanya.json": 615,
	"./Script/Pahawh_Hmong": 616,
	"./Script/Pahawh_Hmong.json": 616,
	"./Script/Palmyrene": 617,
	"./Script/Palmyrene.json": 617,
	"./Script/Pau_Cin_Hau": 618,
	"./Script/Pau_Cin_Hau.json": 618,
	"./Script/Phags_Pa": 619,
	"./Script/Phags_Pa.json": 619,
	"./Script/Phoenician": 620,
	"./Script/Phoenician.json": 620,
	"./Script/Psalter_Pahlavi": 621,
	"./Script/Psalter_Pahlavi.json": 621,
	"./Script/Rejang": 622,
	"./Script/Rejang.json": 622,
	"./Script/Runic": 623,
	"./Script/Runic.json": 623,
	"./Script/Samaritan": 624,
	"./Script/Samaritan.json": 624,
	"./Script/Saurashtra": 625,
	"./Script/Saurashtra.json": 625,
	"./Script/Sharada": 626,
	"./Script/Sharada.json": 626,
	"./Script/Shavian": 627,
	"./Script/Shavian.json": 627,
	"./Script/Siddham": 628,
	"./Script/Siddham.json": 628,
	"./Script/SignWriting": 629,
	"./Script/SignWriting.json": 629,
	"./Script/Sinhala": 630,
	"./Script/Sinhala.json": 630,
	"./Script/Sora_Sompeng": 631,
	"./Script/Sora_Sompeng.json": 631,
	"./Script/Soyombo": 632,
	"./Script/Soyombo.json": 632,
	"./Script/Sundanese": 633,
	"./Script/Sundanese.json": 633,
	"./Script/Syloti_Nagri": 634,
	"./Script/Syloti_Nagri.json": 634,
	"./Script/Syriac": 635,
	"./Script/Syriac.json": 635,
	"./Script/Tagalog": 636,
	"./Script/Tagalog.json": 636,
	"./Script/Tagbanwa": 637,
	"./Script/Tagbanwa.json": 637,
	"./Script/Tai_Le": 638,
	"./Script/Tai_Le.json": 638,
	"./Script/Tai_Tham": 639,
	"./Script/Tai_Tham.json": 639,
	"./Script/Tai_Viet": 640,
	"./Script/Tai_Viet.json": 640,
	"./Script/Takri": 641,
	"./Script/Takri.json": 641,
	"./Script/Tamil": 642,
	"./Script/Tamil.json": 642,
	"./Script/Tangut": 643,
	"./Script/Tangut.json": 643,
	"./Script/Telugu": 644,
	"./Script/Telugu.json": 644,
	"./Script/Thaana": 645,
	"./Script/Thaana.json": 645,
	"./Script/Thai": 646,
	"./Script/Thai.json": 646,
	"./Script/Tibetan": 647,
	"./Script/Tibetan.json": 647,
	"./Script/Tifinagh": 648,
	"./Script/Tifinagh.json": 648,
	"./Script/Tirhuta": 649,
	"./Script/Tirhuta.json": 649,
	"./Script/Ugaritic": 650,
	"./Script/Ugaritic.json": 650,
	"./Script/Vai": 651,
	"./Script/Vai.json": 651,
	"./Script/Warang_Citi": 652,
	"./Script/Warang_Citi.json": 652,
	"./Script/Yi": 653,
	"./Script/Yi.json": 653,
	"./Script/Zanabazar_Square": 654,
	"./Script/Zanabazar_Square.json": 654,
	"./Script_Extensions/Adlam": 655,
	"./Script_Extensions/Adlam.json": 655,
	"./Script_Extensions/Ahom": 656,
	"./Script_Extensions/Ahom.json": 656,
	"./Script_Extensions/Anatolian_Hieroglyphs": 657,
	"./Script_Extensions/Anatolian_Hieroglyphs.json": 657,
	"./Script_Extensions/Arabic": 658,
	"./Script_Extensions/Arabic.json": 658,
	"./Script_Extensions/Armenian": 659,
	"./Script_Extensions/Armenian.json": 659,
	"./Script_Extensions/Avestan": 660,
	"./Script_Extensions/Avestan.json": 660,
	"./Script_Extensions/Balinese": 661,
	"./Script_Extensions/Balinese.json": 661,
	"./Script_Extensions/Bamum": 662,
	"./Script_Extensions/Bamum.json": 662,
	"./Script_Extensions/Bassa_Vah": 663,
	"./Script_Extensions/Bassa_Vah.json": 663,
	"./Script_Extensions/Batak": 664,
	"./Script_Extensions/Batak.json": 664,
	"./Script_Extensions/Bengali": 665,
	"./Script_Extensions/Bengali.json": 665,
	"./Script_Extensions/Bhaiksuki": 666,
	"./Script_Extensions/Bhaiksuki.json": 666,
	"./Script_Extensions/Bopomofo": 667,
	"./Script_Extensions/Bopomofo.json": 667,
	"./Script_Extensions/Brahmi": 668,
	"./Script_Extensions/Brahmi.json": 668,
	"./Script_Extensions/Braille": 669,
	"./Script_Extensions/Braille.json": 669,
	"./Script_Extensions/Buginese": 670,
	"./Script_Extensions/Buginese.json": 670,
	"./Script_Extensions/Buhid": 671,
	"./Script_Extensions/Buhid.json": 671,
	"./Script_Extensions/Canadian_Aboriginal": 672,
	"./Script_Extensions/Canadian_Aboriginal.json": 672,
	"./Script_Extensions/Carian": 673,
	"./Script_Extensions/Carian.json": 673,
	"./Script_Extensions/Caucasian_Albanian": 674,
	"./Script_Extensions/Caucasian_Albanian.json": 674,
	"./Script_Extensions/Chakma": 675,
	"./Script_Extensions/Chakma.json": 675,
	"./Script_Extensions/Cham": 676,
	"./Script_Extensions/Cham.json": 676,
	"./Script_Extensions/Cherokee": 677,
	"./Script_Extensions/Cherokee.json": 677,
	"./Script_Extensions/Common": 678,
	"./Script_Extensions/Common.json": 678,
	"./Script_Extensions/Coptic": 679,
	"./Script_Extensions/Coptic.json": 679,
	"./Script_Extensions/Cuneiform": 680,
	"./Script_Extensions/Cuneiform.json": 680,
	"./Script_Extensions/Cypriot": 681,
	"./Script_Extensions/Cypriot.json": 681,
	"./Script_Extensions/Cyrillic": 682,
	"./Script_Extensions/Cyrillic.json": 682,
	"./Script_Extensions/Deseret": 683,
	"./Script_Extensions/Deseret.json": 683,
	"./Script_Extensions/Devanagari": 684,
	"./Script_Extensions/Devanagari.json": 684,
	"./Script_Extensions/Duployan": 685,
	"./Script_Extensions/Duployan.json": 685,
	"./Script_Extensions/Egyptian_Hieroglyphs": 686,
	"./Script_Extensions/Egyptian_Hieroglyphs.json": 686,
	"./Script_Extensions/Elbasan": 687,
	"./Script_Extensions/Elbasan.json": 687,
	"./Script_Extensions/Ethiopic": 688,
	"./Script_Extensions/Ethiopic.json": 688,
	"./Script_Extensions/Georgian": 689,
	"./Script_Extensions/Georgian.json": 689,
	"./Script_Extensions/Glagolitic": 690,
	"./Script_Extensions/Glagolitic.json": 690,
	"./Script_Extensions/Gothic": 691,
	"./Script_Extensions/Gothic.json": 691,
	"./Script_Extensions/Grantha": 692,
	"./Script_Extensions/Grantha.json": 692,
	"./Script_Extensions/Greek": 693,
	"./Script_Extensions/Greek.json": 693,
	"./Script_Extensions/Gujarati": 694,
	"./Script_Extensions/Gujarati.json": 694,
	"./Script_Extensions/Gurmukhi": 695,
	"./Script_Extensions/Gurmukhi.json": 695,
	"./Script_Extensions/Han": 696,
	"./Script_Extensions/Han.json": 696,
	"./Script_Extensions/Hangul": 697,
	"./Script_Extensions/Hangul.json": 697,
	"./Script_Extensions/Hanunoo": 698,
	"./Script_Extensions/Hanunoo.json": 698,
	"./Script_Extensions/Hatran": 699,
	"./Script_Extensions/Hatran.json": 699,
	"./Script_Extensions/Hebrew": 700,
	"./Script_Extensions/Hebrew.json": 700,
	"./Script_Extensions/Hiragana": 701,
	"./Script_Extensions/Hiragana.json": 701,
	"./Script_Extensions/Imperial_Aramaic": 702,
	"./Script_Extensions/Imperial_Aramaic.json": 702,
	"./Script_Extensions/Inherited": 703,
	"./Script_Extensions/Inherited.json": 703,
	"./Script_Extensions/Inscriptional_Pahlavi": 704,
	"./Script_Extensions/Inscriptional_Pahlavi.json": 704,
	"./Script_Extensions/Inscriptional_Parthian": 705,
	"./Script_Extensions/Inscriptional_Parthian.json": 705,
	"./Script_Extensions/Javanese": 706,
	"./Script_Extensions/Javanese.json": 706,
	"./Script_Extensions/Kaithi": 707,
	"./Script_Extensions/Kaithi.json": 707,
	"./Script_Extensions/Kannada": 708,
	"./Script_Extensions/Kannada.json": 708,
	"./Script_Extensions/Katakana": 709,
	"./Script_Extensions/Katakana.json": 709,
	"./Script_Extensions/Kayah_Li": 710,
	"./Script_Extensions/Kayah_Li.json": 710,
	"./Script_Extensions/Kharoshthi": 711,
	"./Script_Extensions/Kharoshthi.json": 711,
	"./Script_Extensions/Khmer": 712,
	"./Script_Extensions/Khmer.json": 712,
	"./Script_Extensions/Khojki": 713,
	"./Script_Extensions/Khojki.json": 713,
	"./Script_Extensions/Khudawadi": 714,
	"./Script_Extensions/Khudawadi.json": 714,
	"./Script_Extensions/Lao": 715,
	"./Script_Extensions/Lao.json": 715,
	"./Script_Extensions/Latin": 716,
	"./Script_Extensions/Latin.json": 716,
	"./Script_Extensions/Lepcha": 717,
	"./Script_Extensions/Lepcha.json": 717,
	"./Script_Extensions/Limbu": 718,
	"./Script_Extensions/Limbu.json": 718,
	"./Script_Extensions/Linear_A": 719,
	"./Script_Extensions/Linear_A.json": 719,
	"./Script_Extensions/Linear_B": 720,
	"./Script_Extensions/Linear_B.json": 720,
	"./Script_Extensions/Lisu": 721,
	"./Script_Extensions/Lisu.json": 721,
	"./Script_Extensions/Lycian": 722,
	"./Script_Extensions/Lycian.json": 722,
	"./Script_Extensions/Lydian": 723,
	"./Script_Extensions/Lydian.json": 723,
	"./Script_Extensions/Mahajani": 724,
	"./Script_Extensions/Mahajani.json": 724,
	"./Script_Extensions/Malayalam": 725,
	"./Script_Extensions/Malayalam.json": 725,
	"./Script_Extensions/Mandaic": 726,
	"./Script_Extensions/Mandaic.json": 726,
	"./Script_Extensions/Manichaean": 727,
	"./Script_Extensions/Manichaean.json": 727,
	"./Script_Extensions/Marchen": 728,
	"./Script_Extensions/Marchen.json": 728,
	"./Script_Extensions/Masaram_Gondi": 729,
	"./Script_Extensions/Masaram_Gondi.json": 729,
	"./Script_Extensions/Meetei_Mayek": 730,
	"./Script_Extensions/Meetei_Mayek.json": 730,
	"./Script_Extensions/Mende_Kikakui": 731,
	"./Script_Extensions/Mende_Kikakui.json": 731,
	"./Script_Extensions/Meroitic_Cursive": 732,
	"./Script_Extensions/Meroitic_Cursive.json": 732,
	"./Script_Extensions/Meroitic_Hieroglyphs": 733,
	"./Script_Extensions/Meroitic_Hieroglyphs.json": 733,
	"./Script_Extensions/Miao": 734,
	"./Script_Extensions/Miao.json": 734,
	"./Script_Extensions/Modi": 735,
	"./Script_Extensions/Modi.json": 735,
	"./Script_Extensions/Mongolian": 736,
	"./Script_Extensions/Mongolian.json": 736,
	"./Script_Extensions/Mro": 737,
	"./Script_Extensions/Mro.json": 737,
	"./Script_Extensions/Multani": 738,
	"./Script_Extensions/Multani.json": 738,
	"./Script_Extensions/Myanmar": 739,
	"./Script_Extensions/Myanmar.json": 739,
	"./Script_Extensions/Nabataean": 740,
	"./Script_Extensions/Nabataean.json": 740,
	"./Script_Extensions/New_Tai_Lue": 741,
	"./Script_Extensions/New_Tai_Lue.json": 741,
	"./Script_Extensions/Newa": 742,
	"./Script_Extensions/Newa.json": 742,
	"./Script_Extensions/Nko": 743,
	"./Script_Extensions/Nko.json": 743,
	"./Script_Extensions/Nushu": 744,
	"./Script_Extensions/Nushu.json": 744,
	"./Script_Extensions/Ogham": 745,
	"./Script_Extensions/Ogham.json": 745,
	"./Script_Extensions/Ol_Chiki": 746,
	"./Script_Extensions/Ol_Chiki.json": 746,
	"./Script_Extensions/Old_Hungarian": 747,
	"./Script_Extensions/Old_Hungarian.json": 747,
	"./Script_Extensions/Old_Italic": 748,
	"./Script_Extensions/Old_Italic.json": 748,
	"./Script_Extensions/Old_North_Arabian": 749,
	"./Script_Extensions/Old_North_Arabian.json": 749,
	"./Script_Extensions/Old_Permic": 750,
	"./Script_Extensions/Old_Permic.json": 750,
	"./Script_Extensions/Old_Persian": 751,
	"./Script_Extensions/Old_Persian.json": 751,
	"./Script_Extensions/Old_South_Arabian": 752,
	"./Script_Extensions/Old_South_Arabian.json": 752,
	"./Script_Extensions/Old_Turkic": 753,
	"./Script_Extensions/Old_Turkic.json": 753,
	"./Script_Extensions/Oriya": 754,
	"./Script_Extensions/Oriya.json": 754,
	"./Script_Extensions/Osage": 755,
	"./Script_Extensions/Osage.json": 755,
	"./Script_Extensions/Osmanya": 756,
	"./Script_Extensions/Osmanya.json": 756,
	"./Script_Extensions/Pahawh_Hmong": 757,
	"./Script_Extensions/Pahawh_Hmong.json": 757,
	"./Script_Extensions/Palmyrene": 758,
	"./Script_Extensions/Palmyrene.json": 758,
	"./Script_Extensions/Pau_Cin_Hau": 759,
	"./Script_Extensions/Pau_Cin_Hau.json": 759,
	"./Script_Extensions/Phags_Pa": 760,
	"./Script_Extensions/Phags_Pa.json": 760,
	"./Script_Extensions/Phoenician": 761,
	"./Script_Extensions/Phoenician.json": 761,
	"./Script_Extensions/Psalter_Pahlavi": 762,
	"./Script_Extensions/Psalter_Pahlavi.json": 762,
	"./Script_Extensions/Rejang": 763,
	"./Script_Extensions/Rejang.json": 763,
	"./Script_Extensions/Runic": 764,
	"./Script_Extensions/Runic.json": 764,
	"./Script_Extensions/Samaritan": 765,
	"./Script_Extensions/Samaritan.json": 765,
	"./Script_Extensions/Saurashtra": 766,
	"./Script_Extensions/Saurashtra.json": 766,
	"./Script_Extensions/Sharada": 767,
	"./Script_Extensions/Sharada.json": 767,
	"./Script_Extensions/Shavian": 768,
	"./Script_Extensions/Shavian.json": 768,
	"./Script_Extensions/Siddham": 769,
	"./Script_Extensions/Siddham.json": 769,
	"./Script_Extensions/SignWriting": 770,
	"./Script_Extensions/SignWriting.json": 770,
	"./Script_Extensions/Sinhala": 771,
	"./Script_Extensions/Sinhala.json": 771,
	"./Script_Extensions/Sora_Sompeng": 772,
	"./Script_Extensions/Sora_Sompeng.json": 772,
	"./Script_Extensions/Soyombo": 773,
	"./Script_Extensions/Soyombo.json": 773,
	"./Script_Extensions/Sundanese": 774,
	"./Script_Extensions/Sundanese.json": 774,
	"./Script_Extensions/Syloti_Nagri": 775,
	"./Script_Extensions/Syloti_Nagri.json": 775,
	"./Script_Extensions/Syriac": 776,
	"./Script_Extensions/Syriac.json": 776,
	"./Script_Extensions/Tagalog": 777,
	"./Script_Extensions/Tagalog.json": 777,
	"./Script_Extensions/Tagbanwa": 778,
	"./Script_Extensions/Tagbanwa.json": 778,
	"./Script_Extensions/Tai_Le": 779,
	"./Script_Extensions/Tai_Le.json": 779,
	"./Script_Extensions/Tai_Tham": 780,
	"./Script_Extensions/Tai_Tham.json": 780,
	"./Script_Extensions/Tai_Viet": 781,
	"./Script_Extensions/Tai_Viet.json": 781,
	"./Script_Extensions/Takri": 782,
	"./Script_Extensions/Takri.json": 782,
	"./Script_Extensions/Tamil": 783,
	"./Script_Extensions/Tamil.json": 783,
	"./Script_Extensions/Tangut": 784,
	"./Script_Extensions/Tangut.json": 784,
	"./Script_Extensions/Telugu": 785,
	"./Script_Extensions/Telugu.json": 785,
	"./Script_Extensions/Thaana": 786,
	"./Script_Extensions/Thaana.json": 786,
	"./Script_Extensions/Thai": 787,
	"./Script_Extensions/Thai.json": 787,
	"./Script_Extensions/Tibetan": 788,
	"./Script_Extensions/Tibetan.json": 788,
	"./Script_Extensions/Tifinagh": 789,
	"./Script_Extensions/Tifinagh.json": 789,
	"./Script_Extensions/Tirhuta": 790,
	"./Script_Extensions/Tirhuta.json": 790,
	"./Script_Extensions/Ugaritic": 791,
	"./Script_Extensions/Ugaritic.json": 791,
	"./Script_Extensions/Vai": 792,
	"./Script_Extensions/Vai.json": 792,
	"./Script_Extensions/Warang_Citi": 793,
	"./Script_Extensions/Warang_Citi.json": 793,
	"./Script_Extensions/Yi": 794,
	"./Script_Extensions/Yi.json": 794,
	"./Script_Extensions/Zanabazar_Square": 795,
	"./Script_Extensions/Zanabazar_Square.json": 795,
	"./Word_Break/ALetter": 796,
	"./Word_Break/ALetter.json": 796,
	"./Word_Break/CR": 797,
	"./Word_Break/CR.json": 797,
	"./Word_Break/Double_Quote": 798,
	"./Word_Break/Double_Quote.json": 798,
	"./Word_Break/E_Base": 799,
	"./Word_Break/E_Base.json": 799,
	"./Word_Break/E_Base_GAZ": 800,
	"./Word_Break/E_Base_GAZ.json": 800,
	"./Word_Break/E_Modifier": 801,
	"./Word_Break/E_Modifier.json": 801,
	"./Word_Break/Extend": 802,
	"./Word_Break/Extend.json": 802,
	"./Word_Break/ExtendNumLet": 803,
	"./Word_Break/ExtendNumLet.json": 803,
	"./Word_Break/Format": 804,
	"./Word_Break/Format.json": 804,
	"./Word_Break/Glue_After_Zwj": 805,
	"./Word_Break/Glue_After_Zwj.json": 805,
	"./Word_Break/Hebrew_Letter": 806,
	"./Word_Break/Hebrew_Letter.json": 806,
	"./Word_Break/Katakana": 807,
	"./Word_Break/Katakana.json": 807,
	"./Word_Break/LF": 808,
	"./Word_Break/LF.json": 808,
	"./Word_Break/MidLetter": 809,
	"./Word_Break/MidLetter.json": 809,
	"./Word_Break/MidNum": 810,
	"./Word_Break/MidNum.json": 810,
	"./Word_Break/MidNumLet": 811,
	"./Word_Break/MidNumLet.json": 811,
	"./Word_Break/Newline": 812,
	"./Word_Break/Newline.json": 812,
	"./Word_Break/Numeric": 813,
	"./Word_Break/Numeric.json": 813,
	"./Word_Break/Other": 814,
	"./Word_Break/Other.json": 814,
	"./Word_Break/Regional_Indicator": 815,
	"./Word_Break/Regional_Indicator.json": 815,
	"./Word_Break/Single_Quote": 816,
	"./Word_Break/Single_Quote.json": 816,
	"./Word_Break/ZWJ": 817,
	"./Word_Break/ZWJ.json": 817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 843;